import React from 'react';

import { Box, COLORS, FontWeight, Text } from '@clutter/clean';

import { Plan } from '@root/constants/pricing';

import lightBulbRotated from '@images/illustrations/light_bulb_rotated.svg';

export const Banner: React.FC<{ plan?: Plan }> = ({ plan }) => {
  return (
    <Box
      position="relative"
      margin="24px 0 0"
      background="#EFEFEF"
      color={COLORS.tealDark}
      borderRadius="4px"
      border={`1px solid ${COLORS.grayBorder}`}
      minHeight="100px"
      overflow="hidden"
    >
      <Box
        position="absolute"
        left="-7px"
        bottom="-5px"
        display={['none', null, 'block']}
        style={{ pointerEvents: 'none' }}
      >
        <img
          src={lightBulbRotated}
          alt=""
          style={{
            display: 'block',
            margin: 0,
            padding: 0,
            height: '82px',
            width: '67px',
            overflow: 'hidden',
          }}
          draggable={false}
        />
      </Box>
      <Box
        position="absolute"
        bottom="-4px"
        right="-5px"
        display={['block', null, 'none']}
        style={{ pointerEvents: 'none' }}
      >
        <img
          src={lightBulbRotated}
          alt=""
          style={{
            display: 'block',
            margin: 0,
            padding: 0,
            transform: 'scaleX(-1)',
            height: '63px',
            width: '52px',
          }}
          draggable={false}
        />
      </Box>
      <Box
        padding={['12px 36px 12px 24px', null, '18px 18px 18px 80px']}
        position="relative"
      >
        <Box>
          <Box margin="0 0 8px">
            <Text.Body weight={FontWeight.Medium}>
              {plan
                ? `You’ve selected: ${plan.label}`
                : 'Select a storage size'}
            </Text.Body>
          </Box>
          <Text.Callout>
            Your space, simplified. Instantly see everything you store and
            schedule pickups or deliveries with ease.
          </Text.Callout>
        </Box>
      </Box>
    </Box>
  );
};
